import { DroneCamera } from './types';

// Drone deployment demo — remove entirely when show-drone-demo flag is retired
export const DEMO_DRONE_CAMERA: DroneCamera = {
  id: 'drone-demo-001',
  name: 'Skydio X10',
  url: '',
  location: '',
  isLive: false,
  hasFootage: false,
  oldestRecording: '',
  currentThumbnailUrl: '',
  type: 'drone',
  droneStatus: 'idle',
};

export const DRONE_FEED_URL =
  'https://vpe1publicsa01.blob.core.windows.net/public/13504979_640_360_30fps.mp4';
